export enum InvitationEvent {
  userLogin = '[AppWEB Resident Auto] User Login',
  homeViewed = '[AppWEB Resident Auto] Home viewed',
  newAccessStarted = '[AppWEB Resident Auto] New access started',
  newAccessRegistered = '[AppWEB Resident Auto] New access registered',
  newAccessCreated = '[AppWEB Backend] New access created',
  accessOpened = '[AppWEB Resident Auto] Access Opened',
  shareAccessLink = '[AppWEB Resident Auto] Share access link',
  accessDeleted = '[AppWEB Resident Auto] Access Deleted',
  passwordUpdated = '[AppWEB Resident Auto] Password Updated',
  userLogOut = '[AppWEB Resident Auto] User Log Out',
  passwordChangeEmailSent = '[Backend] Password Change Email sent',
  tncAccepted = '[AppWEB Resident Auto] T&C Accepted'
}

export enum InvitationChanel {
  phone = 'phone',
  mail = 'mail',
  both = 'both'
}

export enum PasswordUpdateSource {
  temporal = 'Password Temporal',
  link = 'Link'
}

export class InvitationGenericEvent {}

export class UserLogin extends InvitationGenericEvent {}

export class HomeViewed extends InvitationGenericEvent {}

export class NewAccessStarted extends InvitationGenericEvent {}

export class NewAccessRegistered extends InvitationGenericEvent {
  'Chanel': InvitationChanel;
  'Guests number': number;
}

export class NewAccessCreated extends InvitationGenericEvent {}

export class AccessOpened extends InvitationGenericEvent {}

export class ShareAccessLink extends InvitationGenericEvent {}

export class AccessDeleted extends InvitationGenericEvent {}

export class PasswordUpdated extends InvitationGenericEvent {
  'Source Password Update': PasswordUpdateSource;
}

export class UserLogOut extends InvitationGenericEvent {}

export class PasswordChangeEmailSent extends InvitationGenericEvent {
  'Email sent': boolean;
}

export class TncAccepted extends InvitationGenericEvent {}

export type InvitationEventData =
  | UserLogin
  | HomeViewed
  | NewAccessStarted
  | NewAccessRegistered
  | NewAccessCreated
  | AccessOpened
  | ShareAccessLink
  | AccessDeleted
  | PasswordUpdated
  | UserLogOut
  | PasswordChangeEmailSent
  | TncAccepted;

export type InvitationEventRecord = Record<string, InvitationEventData>;

export const AUTODROMO_WEB_APP_NAME = "AUTODROMO_WEB_APP";
export const AUTODROMO_WEB_APP_ID = "AUTODROMO_WEB_APP_AMPLITUDE";
